
import { CountrySelect } from "@/components/tender-agent/CountrySelect";
import { useTranslation } from "react-i18next";

interface CountrySectionProps {
  selectedCountries: string[];
  onCountryChange: (country: string) => void;
}

export const CountrySection = ({
  selectedCountries,
  onCountryChange,
}: CountrySectionProps) => {
  const { t } = useTranslation("profile");
  
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">{t("countries.title")}</h2>
      <p className="text-sm text-gray-600">
        {t("countries.description")}
      </p>
      <CountrySelect
        selectedCountries={selectedCountries}
        onCountryChange={onCountryChange}
      />
    </div>
  );
};
